/*
  VENA DEMO-ONLY REVIEW DATA
  These synthetic placeholders are for internal design demonstration only.
  Before public launch, replace window.VenaDemoReviewData.get with a Loox adapter
  that returns approved customer reviews in the same shape.
*/
window.VenaDemoReviewData = (() => {
  const people = [
    ['Maya R.', '52', 'Austin, TX'], ['Olivia P.', '49', 'Nashville, TN'], ['Elena C.', '56', 'San Diego, CA'],
    ['Danielle S.', '47', 'Chicago, IL'], ['Monica L.', '54', 'Tampa, FL'], ['Erin W.', '50', 'Portland, OR'],
    ['Tara B.', '58', 'Denver, CO'], ['Renee J.', '45', 'Atlanta, GA'], ['Heather K.', '53', 'Charlotte, NC'],
    ['Alicia M.', '48', 'Boston, MA'], ['Nina G.', '57', 'Scottsdale, AZ'], ['Lauren D.', '51', 'Minneapolis, MN']
  ];
  const tags = ['Mature & dry skin', 'Arms & décolletage', 'Post-shower tightness', 'Skin comfort ritual', 'Visible softness', 'Body-care routine'];
  const reviews = [
    'I kept my routine simple and noticed my skin felt more comfortable after showering. The finish feels nourishing without making me wait to get dressed.',
    'This is the kind of body-care ritual I had been looking for. My arms feel softer and the texture looks more even in the morning light.',
    'I like that it absorbs quickly but still leaves my skin feeling cared for. It has become the product I reach for most consistently.',
    'After several weeks I noticed less of that tight, papery feeling. My skin looks more hydrated and feels much more comfortable.',
    'The scent-free, uncomplicated routine works for me. I appreciate how it makes my skin feel without adding another complicated step.',
    'I was looking for a body oil that felt elegant instead of messy. This leaves a soft finish and makes my evening routine feel more intentional.',
    'I noticed the biggest difference on my arms and legs. My skin feels smoother to the touch and I feel more confident in sleeveless clothes.',
    'The texture is rich but not heavy. I use it after a shower and my skin still feels comfortable later in the day.',
    'My body skin had been feeling different for a while, and this was a simple change that made my routine feel more supportive.',
    'It feels like a small luxury that actually fits into everyday life. My skin looks calmer and has a healthier-looking glow.'
  ];

  const get = (offset, limit, productName) => Array.from({ length: limit }, (_, position) => {
    const index = offset + position;
    const person = people[index % people.length];
    const review = reviews[index % reviews.length];
    return {
      product: productName || 'Vena Pure Magic Body Oil',
      tag: tags[index % tags.length],
      name: `${person[0]}, ${person[1]}`,
      location: person[2],
      initials: person[0].split(' ').map((part) => part[0]).join(''),
      rating: index % 5 === 3 ? 4.5 : 5,
      body: review,
      detail: `Demo review card · story ${String((index % 24) + 1).padStart(2, '0')}`
    };
  });

  return { get };
})();
